import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-shop-revamp',
  imports: [],
  templateUrl: './loader-shop-revamp.component.html',
  standalone: true
})
export class LoaderShopRevampComponent {

}
